import { AuctionModalActionType } from '../../types/auctionModalType'

export const closeAuctionModal = () => {
    return {type: AuctionModalActionType.CLOSE_AUCTION_MODAL}
}

export const openAuctionModal = () => {
    return {type: AuctionModalActionType.OPEN_AUCTION_MODAL}
}